// While the Copilot panel is open, a file dropped outside every drop zone must
// not make the browser navigate to it (D5). Window listeners run after
// bubbling, so a clinic upload area that handled the drop (preventDefault) is
// left alone; the panel stops propagation itself.
type DragLike = Event & { dataTransfer?: { types?: readonly string[]; dropEffect?: string } | null };

function carriesFiles(event: DragLike): boolean {
  return Array.from(event.dataTransfer?.types ?? []).includes("Files");
}

export function installWindowDropGuard(target: Window = window): () => void {
  const onDragOver = (event: Event) => {
    const drag = event as DragLike;
    if (drag.defaultPrevented || !carriesFiles(drag)) return;
    drag.preventDefault();
    if (drag.dataTransfer) drag.dataTransfer.dropEffect = "none";
  };
  const onDrop = (event: Event) => {
    const drag = event as DragLike;
    if (!drag.defaultPrevented && carriesFiles(drag)) drag.preventDefault();
  };
  target.addEventListener("dragover", onDragOver);
  target.addEventListener("drop", onDrop);
  return () => {
    target.removeEventListener("dragover", onDragOver);
    target.removeEventListener("drop", onDrop);
  };
}
